<template>
  <div class="hall">
    <a class="hall-zoom hall-zoom-touch"></a>

    <DragItDude
      class="hall-wrapper"
      v-if="places"
      :parent-width="4 * hallHeight * (2 * scaleValue)"
      :parent-height="4 * hallWidth * (2 * scaleValue)"
      :style="{
        left: '50%',
        top: '50%',
        transform: 'translate(-51%, -51%)',
      }"
    >
      <PinchZoom
        overflow="visible"
        disablePan="true"
        draggableImage="false"
        v-bind:limit-zoom="2"
        :style="{
          top: `calc(-50% + ${hallHeight / (2 / scaleValue) + topPadding}px)`,
          left: `calc(-50% + ${hallWidth / (2 / scaleValue)}px)`,
        }"
      >
        <div
          class="hall-screen"
          :style="{ width: hallWidth * scaleValue + 'px', height: 'auto' }"
        >
          <svg viewBox="0 0 525 55">
            <path
              _ngcontent-c8=""
              fill="#23262a"
              d="M 5 50 q 262.5 -40 515 0"
              stroke-linecap="round"
              stroke="#59636b"
              stroke-width="5"
            ></path>
          </svg>
        </div>
        <div
          class="hall-places"
          :style="{
            width: hallWidth * scaleValue + 'px',
            height: hallHeight * scaleValue + 'px',
          }"
        >
          <div
            class="place-row"
            v-for="row in rows"
            :key="row.id"
            :style="{
              left: 0,
              top: row.y * scaleValue - 8 + 'px',
              fontSize: 16 * scaleValue + 'px',
            }"
          >
            {{ row.label }}
          </div>
          <Place
            v-for="(place, placeIndex) in places"
            :key="placeIndex"
            :place="place"
            :scaleValue="scaleValue"
          ></Place>
          <div
            class="place-row"
            v-for="row in rows"
            :key="row.id"
            :style="{
              left: '100%',
              top: row.y * scaleValue - 8 + 'px',
              fontSize: 16 * scaleValue + 'px',
            }"
          >
            {{ row.label }}
          </div>
        </div>
      </PinchZoom>
    </DragItDude>

    <!-- {{ log(cart.tickets) }} -->

    <WarningModal
      v-if='true'
      v-bind:icon="warningImage"
      v-bind:title="warningTitle"
      v-bind:text="warningText"
    />


  </div>
</template>

<script>
import { mapState } from 'vuex';
import { maxBy } from 'lodash';
import Place from '@/components/Place';
import { types } from '@/types';
import PinchZoom from 'vue-pinch-zoom';
import drag from '@branu-jp/v-drag';
import DragItDude from 'vue-drag-it-dude';
import WarningModal from '@/components/WarningModal';

export default {
  name: 'Hall',

  directives: {
    drag,
  },

  components: {
    Place,
    PinchZoom,
    DragItDude,
    WarningModal,
  },

  data() {
    return {
      switchControlSelectTypeSVG: require('../assets/switch-control-select-type.svg'),
      isOpenControlTypeTickets: true,
      window: {
        width: 0,
      },
      scaleValue: 0.5,
      scaleStepValue: 0.15,
      topPadding: 20,
      warningImage: '',
      warningTitle: '',
      warningText: '',
    };
  },
  mounted() {
    if (this.$route.query.domain) {
      this.$store.commit('SET_DOMAIN', this.$route.query.domain)
    }
  },

  computed: {
    ...mapState(['places', 'cart', 'session', 'rows', 'setting', 'user']),
    typePlacesSelectedTickets() {
      return this.cart.tickets
        .filter(
          (ticket, index, array) =>
            !array.slice(0, index).find((i) => i.name == ticket.name),
        )
        .map(({ name, variants }) => ({
          name,
          variants,
          count: this.cart.tickets.filter((i) => i.name === name).length,
        }));
    },
    hallWidth() {
      if (this.places.length) {
        let width = maxBy(this.places, 'X')['X'];
        width += 70;
        // remove last char from value. Like 758 become 750
        return width.toString().slice(0, -1) + '0';
      }
    },
    hallHeight() {
      if (this.places.length) {
        let height = maxBy(this.places, 'Y')['Y'];
        height += 70;
        // remove last char from value. Like 758 become 750
        return height.toString().slice(0, -1) + '0';
      }
    },
  },

  created() {
    if (this.user.ticketOrderId) {
      this.$store
        .dispatch('cancelReserveTicket', {
          theatreId: this.$route.params.theatreId,
        })
        .then(() => {
          this.$store.commit(types.SET_TICKET_ORDER_ID, {
            ticketOrderId: null,
            userSessionEndAt: null,
          });
        });
    }

    // this.$store.dispatch('loadPlaces', {
    //   theatreId: this.$route.params.theatreId,
    //   session: this.$route.params.session
    // });

    window.addEventListener('resize', this.hallResize);
    this.hallResize();

    this.$store.commit(types.RESET_SESSION_END_AT);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {
    places(places) {
      this.hallResize(places);
    },
  },

  methods: {
    decreaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        (ticket) =>
          ticket.name === typeTicketName &&
          ticket.typeId === typeDiscountTicket,
      );

      this.cart.tickets = this.cart.tickets.map((ticket) => {
        if (ticket.id === changeTicket.id) {
          this.cart.sum -= changeTicket.price;
          this.cart.ticketSum -= changeTicket.price;
          return { ...ticket, price: null, typeId: null };
        }

        return ticket;
      });
    },
    increaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        (ticket) => !ticket.price && !ticket.typeId,
      );

      this.cart.tickets = this.cart.tickets.map((ticket) => {
        if (ticket.id === changeTicket.id) {
          const selectedVariants = ticket.variants.find(
            ({ typeId }) => typeId === typeDiscountTicket,
          );
          this.cart.sum += selectedVariants.Sum;
          this.cart.ticketSum += selectedVariants.Sum;
          return {
            ...ticket,
            price: selectedVariants.Sum,
            typeId: typeDiscountTicket,
          };
        }

        return ticket;
      });
    },
    log: (msg) => console.log(msg),

    hallResize(places) {
      let averageCountPlacesInRows =
        places && this.rows ? places.length / this.rows.length : 0;

      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (this.window.width <= 320) {
        this.topPadding = 0;
        this.scaleValue = 0.35;
      } else if (this.window.width <= 480) {
        this.topPadding = -10;
        this.scaleValue = 0.55;
      } else {
        this.scaleValue = 1;

        if (this.window.height <= 789) {
          this.scaleValue = 0.65;
        }

        if (this.window.height <= 580) {
          this.scaleValue = 0.4;
          this.topPadding = 0;
        }
      }


      if (averageCountPlacesInRows > 30) {
        this.scaleValue *= 0.775;
      }

      if (this.rows.length > 24) {
        this.scaleValue *= 0.65;
      }

      if (places && places.length > 1000) {
        this.topPadding = 50;
        this.scaleValue *= 0.52;
      }
    },
  },
  updated() {
    if (
      this.setting.notification1Show &&
      this.session.Format &&
      (this.session.Format.Name == '3D' || !this.setting.notification1Only3d)
    ) {
      this.warningImage = this.setting.notification1Image;
      this.warningTitle = this.setting.notification1Title;
      this.warningText = this.setting.notification1Descr;
      this.$modal.show('warning-modal');
    }
  },
};
</script>

<style lang="scss">
.pinch-zoom-wrapper {
  background: none !important;
  width: 100%;
  height: 100%;

  .pinch-zoom-content {
    flex-direction: column;
  }
}

.hall {
  display: flex;
  justify-content: center;
  align-items: center;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
  overflow: hidden;
  height: calc(100vh - 60px);
  &-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
    transform-origin: 50% 50% 0;
    transform: scale(0.95);
    position: absolute;
  }
  &-zoom {
    position: absolute;
    top: 130px;
    left: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: block;
    width: 55px;
    height: 55px;
    min-width: 55px;
    min-height: 55px;
    outline: 0;
    border: none;
    font-size: 32px;
    background-color: #0000002f;
    color: #fff;
    z-index: 10;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background-color: #00000059;
    }
    &-up {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      border-top-right-radius: 1.5px;
      border-top-left-radius: 1.5px;
    }
    &-down {
      font-size: 32px;
      -webkit-transform: translateY(100%);
      transform: translateY(100%);
      border-bottom-right-radius: 1.5px;
      border-bottom-left-radius: 1.5px;
    }
    &-touch {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      background: #0000002f
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA79JREFUeNrUmmtIFFEUx8d108JKhCIiyA8hRZEVPY0e9KEg1CwsqYjoQ/RJgvpUUR8SCiIoQz8U9ELKsBdhL3uLkZEYFYiiWVFZlFlUW9bartP/6Fm6DfN078zoH37snXHmes/Mueeee3YTVFVVLDQIZIMgiGj+lgzawT2DezPBOvATlILPimyRARacUv8pCrpBGHSCLhACBTr35YNXwr31YLaN/+cIOxc9UP8XGRHRnCvV3DNJ1VcLSJVpQNDGSyL3mQOSwA/wDpwB04RrQpp75hv0lQFmgDuyPMiOAV9BlXC8QzN4UrfmeLBJf0NkToGAw+uPgD3cLgM1BtdFTPr445cBx8Embh8DG8AvxWfZcaFE9vlVfHwebOT2aL8NCLBPmg2kTBj8RVAg+HIKt1P8NOAcaAFZBm6zltuXua0KE7eL2x1+utASXm3ngofCeXKblXx8lZ98WLg3zPMgmye3bwZ0sAuJoZD8PI/bFZwO6EWWOsb2wg+ibkWhVv4sFwZ/Day3CItORA/pu2wDAkLn28AaPr4LVgt+LkOJ/EBSwXApkx/5xAfOU77wJyVqh+PMUQpVc7UwTeA0yIwnF4r5fhp/VoO9YAwYxu7TKnnuZQjtCWARWC7MpwQh2llO4lTNuSmgFoxg96JocwjsdDGYUBCp5GhG7XTwmtedKisXalCtdV+yCzlRkZUL5XEsj+pklUHOd674mC3s4gTwLHivTd0TbGwp+6JCUCK5T9qLNIOb7NIf+5JO+6mhYDrYDm6BsQPNAFGTwVFKgQaqAaTFIGcgG0BaYWdDs5RjcxtnqyEb90Q8MmBi0GLSnAT5wrnHvOBUcEQwUtQjA0aaLUZFJotLOygHCwzuva56o09Gg08CjTY6oAJXJcgCKSAdlKjeqc1oIUvkpG6eg9dZxznMKA8n8dOAiQ8XO+xslseDJzWbhdELYKvsHZRkVdvJhaiMuBvk9rPB/wZT7SxkT8AyDqe1/ciA21QOcrIS0+ZiIZdXavqBASdoOxNPOk3Vus0OI5Us1YOZsR1ZPCTz7iuieqvc2BhkbWhyuIaa5sHTr2FXlr4jo8rCDS5TuqUuXm+e6VXm4hV9U3nA5ae/Txy8G3tiKtE0Ke58b/BC6f3attOoNipD38BBl55+o3bwbu2Jiy32Cn1Vm95JNwygGk6RC/2+9coA0iXQILnPN14aQL66X2J/USMXcqsy19M3R6TxkvobB1569QZ6shSlt64pQ4/8eAMxbVF6fx8RUWzW/DVbW3If+nXAc70L/gowAD4IUyWLJG5sAAAAAElFTkSuQmCC');
      background-size: 32px;
      background-position: center;
      background-repeat: no-repeat;
      border-bottom-right-radius: 1.5px;
      border-bottom-left-radius: 1.5px;
      display: none;
    }
  }
}

.place-row {
  position: absolute;
  color: #59636b;
  font-size: 18px;
}

.hall-places {
  transform: translateY(0);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.hall-screen {
  width: 100%;
  height: 40px;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.hall-zoom {
  top: 0;
}

.hall-zoom-touch {
  display: none;
}

.pz-zoom-button.pz-zoom-control-position-bottom {
  display: none;
}

@media only screen and (orientation: landscape) and (max-width: 998px) {
  .hall,
  .hall-screen,
  .hall-places {
    touch-action: auto;
  }
}

@media only screen and (orientation: landscape) and (max-width: 992px) {
  .hall-zoom {
    top: 0;
  }
}

@media only screen and (max-width: 480px) {
  .header {
    height: 165px;
  }

  .pz-zoom-button.pz-zoom-control-position-bottom {
    display: none;
  }
  .hall-zoom-touch {
    display: block;
  }

  .hall-zoom {
    top: 0;
  }
}

@media only screen and (max-width: 480px) and (orientation: landscape) {
  .header {
    height: 165px;
  }

  .pz-zoom-button.pz-zoom-control-position-bottom {
    display: none;
  }
  .hall-zoom-touch {
    display: block;
  }

  .hall-zoom {
    top: 0;
  }
}

// @media only screen and (orientation: landscape) and (min-width: 600px) {
  .hall {
    height: calc(100vh - 185px);
  }
// }

@media only screen and (max-width: 789px) {
  .hall-zoom-touch {
    display: block;
  }

  .pz-zoom-button.pz-zoom-control-position-bottom {
    display: none;
  }
}


@media only screen and (max-width: 320px) {
  .hall-wrapper {
    height: 100%;
  }

  .hall-zoom-touch {
    width: 45px;
    height: 45px;
    min-width: 40px;
    min-height: 40px;
    font-size: 22px;
  }

  .hall-zoom {
    top: 0;
  }
}

 .hall {
    height: calc(100vh - 185px);
  }

</style>
